import { Link } from "react-router-dom";

interface IBreadcrumb {
  items: {
    text: string;
    href?: string;
    active?: boolean;
  }[];
}

const Breadcrumb = ({ items }: IBreadcrumb) => {
    return (
        <div>
            <ol className="breadcrumb" style={{ background: 'transparent' }}>
            {items.map((item, index) => (
                <li key={index} className={`breadcrumb-item ${item.active ? 'active' : ''}`}>
                {item.active ? (
                    <span style={{
                        fontWeight: 500,
                    }}>{item.text}</span>
                ) : (
                    <Link to={item.href || '#'}>{item.text}</Link>
                )}
                </li>
            ))}
            </ol>
        </div>
        )
}

export default Breadcrumb
